import { Field } from 'formik';
import { Flex, Textarea, Icon, Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { PlusCircle } from '@kula-ai/icons/dual-tone/PlusCircle';
import { useState } from 'react';

export const DescriptionField = ({ name }) => {
  const [showDescription, setShowDescription] = useState(false);

  return (
    <Field name={name}>
      {({ field }) =>
        !showDescription && !field.value ? (
          <Flex
            alignItems="center"
            gap="6px"
            cursor="pointer"
            onClick={() => setShowDescription(true)}
          >
            <Icon color="primary-600" as={PlusCircle} />
            <KText
              size="sm-medium"
              color="primary-600"
              data-test-id="add-description"
            >
              Add description
            </KText>
          </Flex>
        ) : (
          <Box>
            <KText size="sm-medium" mb="8px">
              Description
            </KText>
            <Textarea
              {...field}
              value={field.value || ''}
              maxLength={500}
              border="1px solid"
              borderColor="border-color"
              backgroundColor="white"
              placeholder="Enter description"
              _focus={{ borderColor: 'secondary-300', bg: 'secondary-25' }}
              _hover={{ borderColor: 'none' }}
              maxHeight="200px"
              data-test-id={`input-description`}
            />
          </Box>
        )
      }
    </Field>
  );
};
